// @flow

import { useTranslator, mapTags } from '@gandi/translate';

import { useGetPrice } from 'src/helpers';

import { useOffer } from './modules';

import styles from './HostingPackPrice.scss';

type Props = { fqdn: string };

export function HostingPackPrice({ fqdn }: Props): null | React.MixedElement {
  const { __, formatPrice } = useTranslator();

  const getPrice = useGetPrice();
  const offer = useOffer(fqdn);

  if (!offer) return null;

  const price = getPrice(offer);

  return (
    <div className={styles.price}>
      {mapTags(__('[[price]]/[[periodicity]]'), () => ({
        price: formatPrice(price, offer.currency, { round: true }),
        periodicity: __(
          '<for-translators-use>Periodicity (month)</for-translators-use>mo',
        ),
      }))}
    </div>
  );
}
